export enum SitemapGroupEnum {
  Marketing = 'SitemapMarketingSets',
  Product = 'SitemapProductSets',
}
